var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"web-logo clearfix",on:{"click":_vm.goIndex}},[_c('img',{attrs:{"src":require("@public/static/images/setting/indexLogo.png"),"alt":"","height":"60px"}})])}
var staticRenderFns = []

export { render, staticRenderFns }